import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import { getColorFromVariant } from "../typography/utils"

export const Dialog = styled.dialog`
  width: 100%;
  border: none;
  border-radius: 8px;
  padding: 0;
  background-color: #fff;
  color: ${(props) => props.theme.colors.content.text};
  z-index: 1000; // Ensures the modal is on top of other elements

  &::backdrop {
    background-color: rgba(0, 0, 0, 0.5);
  }

  ${breakpoint("desktop")`
    width: 90%;
    max-width: 30%;
  `}

  ${({ narrow }) =>
    narrow &&
    css`
      width: 360px;
      max-width: unset;

      ${breakpoint("desktop")`
        width: 410px;
      `}
    `}
`

export const HeaderBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 20px;

  ${({ short }) =>
    short &&
    css`
      padding: 10px 20px;
    `}
`
export const Content = styled.div`
  padding: 0 20px 20px;

  ${({ clear }) =>
    clear &&
    css`
      background: white;
    `}
`
